module.exports = __webpack_public_path__ + "img/EME_titlelogo_ST.d9249203.png";